import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';
import { makeQueryString } from '../../util';
import * as MediaUpload from './MediaUpload';

export type V_Detail = {
  '@id': string;
  '@type': 'Lesson';
  id: string;
  title: string;
  video: MediaUpload.BaseView | null;
  userAnswer: {
    '@id': string;
    '@type': 'UserSimpleAnswer';
    id: string;
    answer: string;
  } | null;
  myEngagement: {
    '@id': string;
    '@type': 'UserLessonEngagement';
    questionAnswer: string | null;
    completedAt: string | null;
  } | null;
  isCompleted: boolean | null;
  isSaved: boolean | null;
  slides: Array<{
    '@id': string;
    '@type': 'LessonSlide';
    templateName: string;
    templateData: object;
    position: number;
  }>;
};

export type V_DetailAsAdmin = {
  '@id': string;
  '@type': 'Lesson';
  id: string;
  title: string;
  position: number;
  thumb: MediaUpload.BaseView;
  video: MediaUpload.BaseView | null;
  publishedAt: string | null;
  updatedAt: string | null;
  slides: Array<{
    '@id': string;
    '@type': 'LessonSlide';
    templateName: string;
    templateData: object;
    position: number;
  }>;
};

export type V_ProgramWeekSub = {
  '@id': string;
  '@type': 'Lesson';
  id: string;
  title: string;
  position: number;
  thumb: string;
  video: string | null;
  publishedAt: string | null;
  updatedAt: string | null;
  slides: Array<string>;
};

export type W = {
  title: string;
  position: number;
  thumb: string;
  video: string | null;
  week: string;
  slides: Array<{
    templateName: string;
    templateData: object;
    position: number;
  }>;
};

export function useReadCollectionLessons(
  id: string,
  queryParams?: { 'order[position]'?: string; title?: string },
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V_ProgramWeekSub>>(
    `/program-weeks/${id}/lessons${makeQueryString(queryParams)}`,
    options,
  );
}

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V_Detail>(`/lessons/${id}`, options);
}

export function useReadItemAsAdmin(id: string, options?: ReadConfig) {
  return useApiRead<V_DetailAsAdmin>(`/lessons/${id}/as-admin`, options);
}
